import logo from './logo.png';

export const settings = {
    "title": "Il Portale Trivek",
    "apiUrl": "https://b2b-api.trivek.it/api",
    "storageUrl": "https://b2b-api.trivek.it/",
    "tinyKey": "u2y9r6cw0e1erg33drzg4fs0swwi1zrs85bcin3ynrsxlwz2",
    "googleMapKey": "inserire_chiave_valida",
    "config": {
        "limit": 100,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "gyv_customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "gyv_customer_active": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "gyv_customer_unsolved": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "locale": {
        "currency": 'EUR',
        "country": 'it-IT'
    },
    "logo": logo,
    "usingCache": false
}